module.exports = __webpack_public_path__ + "media/directory/articles_icon-5fae1b4a.svg";